import type { UIEvent } from "react";

export const handlePopupScroll = (
  event: UIEvent<HTMLDivElement>,
  onScrollBottom: () => void,
) => {
  const target = event.currentTarget;
  if (
    target.scrollHeight > target.clientHeight + 1 &&
    target.scrollTop + target.clientHeight >= target.scrollHeight - 10
  ) {
    onScrollBottom();
  }
};
